// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Documentos_CriarreciboResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for criarRecibo /documentos/criarRecibo
 * Proxy to html2pdf-service geraPDF endpoint for creating receipt PDFs
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Documentos_CriarreciboResponseDados {
path?: string
url?: string
folder?: string
owner?: string
owner_id?: number
created_at?: string
}

export type Documentos_CriarreciboResponse = ApiResponse<Documentos_CriarreciboResponseDados>;

registerResponseContract('Documentos_CriarreciboResponse', {
  path:       { type: 'string',  required: false },
  url:        { type: 'string',  required: false },
  folder:     { type: 'string',  required: false },
  owner:      { type: 'string',  required: false },
  owner_id:   { type: 'number',  required: false },
  created_at: { type: 'string',  required: false },
})
